import React, { useEffect, useState } from "react";
import { Printer, ChevronsUpDown, Eye, EllipsisVertical } from "lucide-react";
import { can_visit, exchangeDate } from "../../helpers";
  
  const styles = {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    cursor: "pointer",
  };
  
  export default function ImmunizationDataTable(props) {
    const {
      tableData = [],
      handleSelectAll = () => {},
      handleCheckboxChange = () => {},
      selectAll = false,
      checkedIds = [],
      checkSelected = false,
      handleFormView = () => {},
      handleFormPrint = () => {},
      reloadData = () => {},
      reloadDataFilter = {},
      dataLoading,
      setDataLoading = () => {}
    } = props;

    const [viewStatusOptions, setViewStatusOptions] = useState({});
    const [orderBy, setOrderBy] = useState();
    const handleOrderChange = (name, type = "asc") => {
      name = name.toString();
      setOrderBy(name);
      if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
        if (reloadDataFilter.order_by[1] == "asc") {
          type = "desc";
        }
      }
      const orderFilter = { order_by: [name, type.toString()] };
      const filter_merge = { ...reloadDataFilter, ...orderFilter };
      setDataLoading(true);
      reloadData(filter_merge);
    };
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        setViewStatusOptions({});
      }
    };
  
    useEffect(() => {
      document.addEventListener("click", handleOutsideClick);
      return () => {
        document.removeEventListener("click", handleOutsideClick);
      };
    }, []);
  
    const handleDropdownClick = (index) => {
      setViewStatusOptions((prev) => {
        const newViewStatusOptions = {};
        newViewStatusOptions[index] = !prev[index];
        return newViewStatusOptions;
      });
    };

    return (
      <>
        {checkSelected && (
          <>
            <hr />
            <div className="docpro_data_table_btns">
              {/* <button className="docpro_bordered_btn docpro_fw_600 docpro_red_color">
                <Trash2 width={20} height={20} />
                Delete
              </button> */}
            </div>
          </>
        )}
        <div className="docpro_table_responsive custom-scroll" style={{ minHeight: '200px' }}>
          <table className="docpro_mb_0" style={{ height: "100%" }}>
            <thead>
              <tr>
                <th style={{ width: "45px" }}>
                  {/* <div className="docpro_checkbox" style={{ top: "3px" }}>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                    <label></label>
                  </div> */}
                </th>
                {can_visit("_role_enterprise") && (
                  <>
                    {/* <th 
                      onClick={() => {
                        handleOrderChange("account_name");
                      }}
                      className={orderBy === "account_name" ? "docpro_accent_color" : ""}
                    >
                      <div style={styles}>
                        Practice Name <ChevronsUpDown size={"12"} />
                      </div>
                    </th>
                    <th 
                      onClick={() => {
                        handleOrderChange("location_name");
                      }}
                      className={orderBy === "location_name" ? "docpro_accent_color" : ""}
                    >
                      <div style={styles}>
                        Location <ChevronsUpDown size={"12"} />
                      </div>
                    </th> */}
                    <th> Practice Name </th>
                    <th> Location </th>
                  </>
                )}
                <th
                  onClick={() => {
                    handleOrderChange("last_name");
                  }}
                  className={orderBy === "last_name" ? "docpro_accent_color" : ""}
                >
                  <div style={styles}>
                    Last Name <ChevronsUpDown size={"12"} />
                  </div>
                </th>
                <th>
                  <div
                    onClick={() => {
                      handleOrderChange("first_name");
                    }}
                    className={
                      orderBy === "first_name" ? "docpro_accent_color" : ""
                    }
                  >
                    <div style={styles}>
                      First Name <ChevronsUpDown size={"12"} />
                    </div>
                  </div>
                </th>
                <th
                  onClick={() => {
                    handleOrderChange("birth");
                  }}
                  className={orderBy === "birth" ? "docpro_accent_color" : ""}
                >
                  <div style={styles}>
                    Date of Birth <ChevronsUpDown size={"12"} />
                  </div>
                </th>
                <th
                  onClick={() => {
                    handleOrderChange("sex");
                  }}
                  className={orderBy === "sex" ? "docpro_accent_color" : ""}
                >
                  <div style={styles}>
                    Gender <ChevronsUpDown size={"12"} />
                  </div>
                </th>
                <th
                  onClick={() => {
                    handleOrderChange("phone");
                  }}
                  className={
                    orderBy === "phone" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Phone <ChevronsUpDown size={"12"} />
                  </div>
                </th>
                <th
                  onClick={() => {
                    handleOrderChange("ins_provider");
                  }}
                  className={
                    orderBy === "ins_provider" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Provider <ChevronsUpDown size={"12"} />
                  </div>
                </th>
                <th className="docpro_text_center">Action</th>
              </tr>
            </thead>
            <tbody>
              {!dataLoading ? (
                tableData.length > 0 ? (
                  tableData?.map((item, index) => (
                    <tr key={index} className={`row_${item.id} pointer`}>
                      <td style={{ width: "45px" }}>
                        {/* <div className="docpro_checkbox" style={{ top: "3px" }}>
                          <input
                            type="checkbox"
                            checked={item.checked || false}
                            onChange={() => handleCheckboxChange(item.id)}
                          />
                          <label></label>
                        </div> */}
                      </td>
                      {can_visit("_role_enterprise") && (
                        <>
                          <td> {item.accountName} </td>
                          <td> {item.locationName} </td>
                        </>
                      )}
                      <td className="bulk">
                        <img
                          src={item.avatarImgUrl}
                          alt=""
                          width={28}
                          height={28}
                          style={{
                            marginRight: "10px",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                        {item.lastName}
                      </td>
  
                      <td className="bulk">
                        {item.firstName}
                      </td>
  
                      <td>
                        {exchangeDate(item.dob)}
                      </td>
                      <td>
                        {item.sex}
                      </td>
                      <td className="bulk">
                        {item.mobilePhone}
                      </td>
                      <td>
                        {item.provider}
                      </td>
                    
                      <td className="docpro_text_center">
                        <div className="docpro_icon_btns" phone={item.option2_tel_no}>
                          <div className="dropdown-container relative">
                            <button className="docpro_icon_btn" onClick={() => handleDropdownClick(index)}>
                              <EllipsisVertical width={18} height={18} />
                            </button>
                            {viewStatusOptions[index] && (
                              <div className={`docpro_button_toggle_options ${index > 1 && 'top_position'}`}>
                                <button className="docpro_icon_btn docpro_dropdown_button"
                                  onClick={() => handleFormView(item.id)}
                                >
                                  <Eye width={18} height={18} />
                                  <span>View</span>
                                </button>
                                <button className="docpro_icon_btn docpro_dropdown_button"
                                  onClick={() => handleFormPrint(item.id)}
                                >
                                  <Printer width={18} height={18} />
                                  <span>Print</span>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="no_data docpro_p_0" style={{ height: "200px" }} colSpan={`${can_visit("_role_enterprise") ? 11 : 9}`}>
                      No data available
                    </td>
                  </tr>
                )
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "200px" }} colSpan={`${can_visit("_role_enterprise") ? 11 : 9}`}>
                    Loading...
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </>
    );
  }